export default "__VITE_ASSET__ki2evIrC__"